import { render } from "./AnimeTitle.vue?vue&type=template&id=587e7918&scoped=true"
import script from "./AnimeTitle.vue?vue&type=script&lang=js"
export * from "./AnimeTitle.vue?vue&type=script&lang=js"

import "./AnimeTitle.vue?vue&type=style&index=0&id=587e7918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587e7918"]])

export default __exports__